import React, { useRef, useEffect, useState } from 'react';
import './PatternLock.scss';

function PatternLock({ onComplete, initialPattern }) {
  const canvasRef = useRef(null);
  const [pattern, setPattern] = useState(initialPattern || []);
  const [isDrawing, setIsDrawing] = useState(false);
  const [currentPattern, setCurrentPattern] = useState([]);
  
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    canvas.width = 200;
    canvas.height = 200;
    
    const padding = 20;
    const radius = 8;
    const gridSize = 3;
    const cellSize = (canvas.width - (padding * 2)) / (gridSize - 1);
    
    // Crea la griglia di punti
    const points = [];
    for (let i = 0; i < gridSize; i++) {
      for (let j = 0; j < gridSize; j++) {
        points.push({
          x: padding + j * cellSize,
          y: padding + i * cellSize,
          index: i * gridSize + j
        });
      }
    }

    // Funzione per disegnare i punti
    function drawPoints() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      points.forEach(point => {
        ctx.beginPath();
        ctx.arc(point.x, point.y, radius, 0, Math.PI * 2);
        ctx.fillStyle = currentPattern.includes(point.index) ? '#007bff' : '#666';
        ctx.fill();
      });
    }

    // Funzione per disegnare le linee
    function drawPattern() {
      if (currentPattern.length > 0) {
        ctx.beginPath();
        ctx.strokeStyle = '#007bff';
        ctx.lineWidth = 2;
        currentPattern.forEach((pointIndex, i) => {
          const point = points.find(p => p.index === pointIndex);
          if (i === 0) {
            ctx.moveTo(point.x, point.y);
          } else {
            ctx.lineTo(point.x, point.y);
          }
        });
        ctx.stroke();
      }
    }

    // Eventi touch/mouse
    function handleStart(e) {
      e.preventDefault();
      setIsDrawing(true);
      setCurrentPattern([]);
    }

    function handleMove(e) {
      if (!isDrawing) return;
      e.preventDefault();
      
      const rect = canvas.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;

      points.forEach(point => {
        const distance = Math.sqrt(
          Math.pow(x - point.x, 2) + Math.pow(y - point.y, 2)
        );
        
        if (distance < radius * 2 && !currentPattern.includes(point.index)) {
          setCurrentPattern(prev => [...prev, point.index]);
        }
      });
    }

    function handleEnd() {
      if (!isDrawing) return;
      setIsDrawing(false);
      if (currentPattern.length > 0) {
        setPattern(currentPattern);
        onComplete(currentPattern);
      }
    }

    // Event listeners
    canvas.addEventListener('mousedown', handleStart);
    canvas.addEventListener('mousemove', handleMove);
    canvas.addEventListener('mouseup', handleEnd);
    canvas.addEventListener('touchstart', handleStart);
    canvas.addEventListener('touchmove', handleMove);
    canvas.addEventListener('touchend', handleEnd);

    // Disegna inizialmente
    drawPoints();

    // Effetto di aggiornamento quando cambia il pattern
    if (currentPattern.length > 0) {
      drawPoints();
      drawPattern();
    } else if (pattern.length > 0) {
      setCurrentPattern(pattern);
    }

    // Cleanup
    return () => {
      canvas.removeEventListener('mousedown', handleStart);
      canvas.removeEventListener('mousemove', handleMove);
      canvas.removeEventListener('mouseup', handleEnd);
      canvas.removeEventListener('touchstart', handleStart);
      canvas.removeEventListener('touchmove', handleMove);
      canvas.removeEventListener('touchend', handleEnd);
    };
  }, [currentPattern, pattern, isDrawing, onComplete]);

  return (
    <div className="pattern-lock-container">
      <canvas 
        ref={canvasRef}
        className="pattern-lock-canvas"
        style={{ 
          maxWidth: '200px',
          maxHeight: '200px'
        }}
      />
    </div>
  );
}

export default PatternLock; 